import React from "react";

// reactstrap components
import {
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavLink,
  NavItem,
  Nav,
  Container,
} from "reactstrap";

// core components
import { Link } from "react-router-dom";
import { currentUser } from "../../fb"

export default function NavItems({ collapseOpen, setBodyClick, setCollapseOpen, }) {

  return (
    <Container>
      <div className="navbar-translate">
        <NavLink to="/" tag={Link}>
          <img
            alt="..."
            src={require("../../assets/img/logo/SEPLOGO.png")}
            width="auto"
            style={{ margin: 0, padding: 0, minHeight: "80px", maxHeight: "80px" }}
          />
        </NavLink>
        {/* <NavbarBrand id="navbar-brand" to="/" tag={Link}>

        </NavbarBrand> */}
        <button
          className="navbar-toggler"
          id="navigation"
          type="button"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setBodyClick(true);
            setCollapseOpen(true);
          }}
        >
          <span className="navbar-toggler-bar bar1" />
          <span className="navbar-toggler-bar bar2" />
          <span className="navbar-toggler-bar bar3" />
        </button>
      </div>
      <Collapse navbar isOpen={collapseOpen}>
        <Nav className="ml-auto" navbar>
          <NavItem>
            <NavLink to="/AboutUs" tag={Link}>
              About Us
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/portfolio" tag={Link}>
              Events
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/clients" tag={Link}>
              Clients
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/OurTeam" tag={Link}>
              Team
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/contact-us" tag={Link}>
              Contact Us
            </NavLink>
          </NavItem>
          {
            currentUser() && (
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle className="mr-2" color="default" caret nav>
                  Admin
              </DropdownToggle>
                <DropdownMenu className="dropdown-danger" right>
                  <DropdownItem to="/admin/events" tag={Link}>
                    Edit Events
                </DropdownItem>
                  <DropdownItem to="/admin/eventCategories" tag={Link}>
                    Edit Event Categories
                </DropdownItem>
                  <DropdownItem to="/clients" tag={Link}>
                    Edit Our Partners
                </DropdownItem>
                  <DropdownItem to="/admin/contactUs" tag={Link}>
                    Edit Contact Us
                </DropdownItem>
                  <DropdownItem to="/logout" tag={Link}>
                    Logout
                </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            )}
        </Nav>
      </Collapse>
    </Container>
  );
}
